import { OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { map, Observable } from "rxjs";

import { IPEmail } from "../body/body";
import { AIPEmailBuilderRestService } from "../services";

/**
 * Dynamically creates and revokes an object URL link for previewing an email.
 * On initialization, it converts the provided IPEmail object to HTML and creates a Blob URL.
 * The pipe transforms the IPEmail object into a SafeUrl object for previewing.
 */
@Pipe({
  name: "ipPreviewLink"
})
export class IpPreviewLinkPipe implements PipeTransform, OnDestroy {
  #resourceUrl!: string;

  /**
   * Creates an instance of IpPreviewLinkPipe.
   * @param domSanitizer - Instance of DomSanitizer used to create a SafeUrl object from a URL.
   * @param restService - Instance of AIPEmailBuilderRestService used to convert IPEmail object to HTML.
   */
  constructor(
    readonly domSanitizer: DomSanitizer,
    readonly restService: AIPEmailBuilderRestService
  ) {}

  /**
   * Transforms the IPEmail object to a SafeUrl object for previewing.
   * @param value - The IPEmail object to be previewed.
   * @returns An Observable of SafeUrl object that can be used for previewing.
   * @example
   * ```html
   * <iframe [src]="email | ipPreviewLink" width="100%" height="600px"></iframe>
   * ```
   */
  defaultOptions = {
    color: "#000000",
    font: {
      fallback: "Arial, Helvetica, sans-serif",
      family: "Roboto",
      style: "normal",
      size: 16,
    weight: 400
    },
    lineHeight: {
      value: 16,
    unit: "none"
    },
    padding: {
      top: 10,
      right: 25,
      bottom: 10,
    left: 25
  }
  };
  applyDefaultOptions(structure: any, defaults: any) {
    if (structure?.structures) {
      structure.structures.forEach((s: any) => {
        if (s?.elements) {
          s.elements.forEach((elementRow: any[]) => {
            elementRow.forEach((el: any) => {
              if (
                el.type === "html" 
                // &&
                // el.options &&
                // Object.keys(el.options).length === 0
              ) {
                el.options = { ...defaults };
                el.innerText = el.innerHTML;
                el.type = "text";
                el.blockType = 'html'
              }
              //  else if (
              //   el.type === "navigation" &&
              //   el.options &&
              //   el.options.elements
              // ) {
              //   el.options = el.options;
              //   el.elements = [];
              //   for (const opt of el.options.elements) {
              //     let ele = {
              //       type: "link",
              //       options: {
              //         ...opt,
              //         target: el.options.target,
              //         color: el.options.color,
              //       },
              //     };
              //     el.elements.push(ele);
              //   }

              //   el.type = "navigation";
              // }
              else if (el.type === "navigation") {
                const links = el.options.elements
                  .map(
                    (l: any) =>
                      `<a href="${l?.href}" target="${el?.options?.target}" 
                        style="text-decoration:${el?.options?.textDecoration};color:${el?.options?.color};margin:0 10px;">
                        ${l?.label} </a>`).join("");
                el.type = "text";
                el.innerText = `<div style="text-align:${el?.options?.align};">${links}</div>`;
              }
            });
          });
        }
      });
    }
  }
  transform(value: IPEmail): Observable<SafeUrl> {
 this.applyDefaultOptions(value,this.defaultOptions)
    return this.restService.convert(value).pipe(
      map(({ html, errors }) => {
        this.#resourceUrl = URL.createObjectURL(new Blob([html], { type: "text/html" }));

        console.log('resource',this.#resourceUrl);

        return this.domSanitizer.bypassSecurityTrustResourceUrl(this.#resourceUrl);
      })
    );
  }

  /**
   * Revokes the object URL link on component destruction to free memory.
   */
  ngOnDestroy() {
    URL.revokeObjectURL(this.#resourceUrl);
  }
}
